import { render } from "./smsSettingsNew.vue?vue&type=template&id=476d98bc&scoped=true"
import script from "./smsSettingsNew.vue?vue&type=script&lang=js"
export * from "./smsSettingsNew.vue?vue&type=script&lang=js"

import "./smsSettingsNew.vue?vue&type=style&index=0&id=476d98bc&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476d98bc"]])

export default __exports__